import { render, staticRenderFns } from "./SelectRoles.vue?vue&type=template&id=5d9ce32d&"
import script from "./SelectRoles.vue?vue&type=script&lang=js&"
export * from "./SelectRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports